export interface ServiceArea {
  slug: string;
  name: string;
  county: string;
  population: string;
  avgTemp: string;
  description: string;
  highlights: string[];
  neighborhoods?: string[];
  metaTitle: string;
  metaDescription: string;
}

export const serviceAreas: ServiceArea[] = [
  {
    slug: "surprise",
    name: "Surprise",
    county: "Maricopa County",
    population: "150K+",
    avgTemp: "106°F",
    description: "Surprise is one of the fastest-growing cities in the Phoenix metro, and new homeowners are discovering that sun screens are essential for Arizona living. Valley Sun Screens proudly serves the Surprise community with custom solar screen installations that make your home more comfortable and energy-efficient from day one.",
    highlights: [
      "Surprise's rapid growth means thousands of new homes need sun screens",
      "Custom installations for Sun City Grand and Marley Park communities",
      "New construction homes especially benefit from sun screen additions",
      "Reduce your first summer energy bill shock with proactive installation"
    ],
    neighborhoods: ["Sun City Grand", "Marley Park", "Surprise Farms", "Asante", "Sierra Montana"],
    metaTitle: "Sun Screens Surprise AZ | Solar Screens for New & Existing Homes",
    metaDescription: "Sun screen installation in Surprise, AZ. Perfect for new homes. Block the Arizona heat. Free estimates, fast install. Call (623) 301-4595.",
  },
  {
    slug: "glendale",
    name: "Glendale",
    county: "Maricopa County",
    population: "250K+",
    avgTemp: "107°F",
    description: "Glendale homeowners know the Arizona heat all too well. From the historic neighborhoods near downtown to the newer communities in the Arrowhead area, Valley Sun Screens delivers custom solar screen solutions that keep your home cool and your energy bills low. Our professional installations are built to last through years of intense desert sun.",
    highlights: [
      "Serving Glendale from Historic Downtown to Arrowhead Ranch",
      "Experienced with both older and newer Glendale home styles",
      "Sun screens that reduce AC strain and extend HVAC system life",
      "Competitive pricing for Glendale's diverse neighborhoods"
    ],
    neighborhoods: ["Arrowhead Ranch", "Historic Downtown", "Westgate", "Thunderbird", "Sahuaro Ranch"],
    metaTitle: "Sun Screens Glendale AZ | Professional Solar Screen Installer",
    metaDescription: "Professional sun screen installation in Glendale, AZ. Keep your home cool & save on energy. Free estimates, fast installation. Call (623) 301-4595.",
  },
  {
    slug: "peoria",
    name: "Peoria",
    county: "Maricopa County",
    population: "190K+",
    avgTemp: "106°F",
    description: "Peoria's beautiful master-planned communities and family neighborhoods deserve premium sun screen protection. From Vistancia to Lake Pleasant, Valley Sun Screens helps Peoria homeowners block the harsh Arizona sun while preserving their views of the desert landscape. Our screens are custom-built for each window and professionally installed.",
    highlights: [
      "Popular with Peoria homeowners in Vistancia and Westwing",
      "Custom screens that preserve your mountain and desert views",
      "Peoria's growing communities benefit from energy-efficient upgrades",
      "Same-week installation available for Peoria residents"
    ],
    neighborhoods: ["Vistancia", "Westwing", "Lake Pleasant", "Old Town Peoria", "Sunrise Mountain"],
    metaTitle: "Sun Screens Peoria AZ | Custom Solar Screens Near You",
    metaDescription: "Custom sun screen installation in Peoria, AZ. Preserve your views while blocking heat. Free estimates. Licensed & insured. Call (623) 301-4595.",
  },
  {
    slug: "goodyear",
    name: "Goodyear",
    county: "Maricopa County",
    population: "110K+",
    avgTemp: "107°F",
    description: "Goodyear's West Valley location means intense afternoon sun that can make your home uncomfortable and expensive to cool. Valley Sun Screens specializes in helping Goodyear homeowners combat the heat with custom solar screens that block solar heat gain. From Estrella to Palm Valley, we've got you covered.",
    highlights: [
      "West-facing homes in Goodyear especially benefit from sun screens",
      "Serving Estrella, Palm Valley, and Canyon Trails communities",
      "Combat intense afternoon sun that hits West Valley homes hardest",
      "Professional installation with minimal disruption to your day"
    ],
    neighborhoods: ["Estrella", "Palm Valley", "Canyon Trails", "PebbleCreek", "Litchfield Park"],
    metaTitle: "Sun Screens Goodyear AZ | Beat the West Valley Heat",
    metaDescription: "Sun screen installation in Goodyear, AZ. Beat the West Valley afternoon heat. Block the sun. Free estimates. Call (623) 301-4595.",
  },
  {
    slug: "buckeye",
    name: "Buckeye",
    county: "Maricopa County",
    population: "100K+",
    avgTemp: "107°F",
    description: "Buckeye is booming, and its new communities need sun screen protection built for the Arizona desert. As one of the fastest-growing cities in the nation, Buckeye homeowners are discovering that sun screens are a must-have upgrade. Valley Sun Screens delivers fast, professional installations to keep your new home cool and efficient.",
    highlights: [
      "One of America's fastest-growing cities — and we're growing with it",
      "New construction homes benefit immediately from sun screen installation",
      "Serving Verrado, Tartesso, and Festival Ranch communities",
      "Beat the heat before your first Arizona summer"
    ],
    neighborhoods: ["Verrado", "Tartesso", "Festival Ranch", "Sundance", "Westpark"],
    metaTitle: "Sun Screens Buckeye AZ | Solar Screens for Growing Communities",
    metaDescription: "Sun screen installation in Buckeye, AZ. Perfect for new construction. Block the desert heat. Free estimates. Call (623) 301-4595.",
  },
  {
    slug: "anthem",
    name: "Anthem",
    county: "Maricopa County",
    population: "25K+",
    avgTemp: "107°F",
    description: "Anthem's stunning master-planned communities and golf-course homes deserve top-tier sun screen protection. Valley Sun Screens serves Anthem homeowners with custom solar screens that block intense desert heat, reduce glare, and keep your home comfortable through the long Arizona summer.",
    highlights: [
      "Custom screens for Anthem's unique architectural styles",
      "Helps keep golf-course view homes cooler without blocking scenery",
      "Energy savings for Anthem's large, sun-facing homes",
      "Professional install with minimal disruption to your day"
    ],
    neighborhoods: ["Parkside", "Country Club at Anthem", "Coventry", "Anthem West", "Boulder Pointe"],
    metaTitle: "Sun Screens Anthem AZ | Custom Solar Screen Installation",
    metaDescription: "Custom sun screen installation in Anthem, AZ. Block desert heat & preserve your views. Free estimates. Licensed & insured. Call (623) 301-4595.",
  },
  {
    slug: "avondale",
    name: "Avondale",
    county: "Maricopa County",
    population: "90K+",
    avgTemp: "107°F",
    description: "Avondale homeowners face the full force of the West Valley sun, making quality sun screens essential for comfort and energy savings. Valley Sun Screens provides custom solar screen installations throughout Avondale that block solar heat, keeping your home cooler and your energy bills lower all summer long.",
    highlights: [
      "West Valley sun hits Avondale homes hard — sun screens are essential",
      "Custom color options to match Avondale's diverse home styles",
      "Affordable solutions for every budget",
      "Free in-home estimates with no-pressure quotes"
    ],
    neighborhoods: ["Coldwater Springs", "Crystal Gardens", "Garden Lakes", "Corte Sierra"],
    metaTitle: "Sun Screens Avondale AZ | Affordable Solar Screen Installation",
    metaDescription: "Affordable sun screen installation in Avondale, AZ. Block the West Valley heat. Free estimates, professional install. Call (623) 301-4595.",
  },
  {
    slug: "sun-city",
    name: "Sun City",
    county: "Maricopa County",
    population: "40K+",
    avgTemp: "107°F",
    description: "Sun City's tight-knit community of homeowners deserves comfortable, energy-efficient living. Valley Sun Screens helps Sun City residents block the harsh West Valley sun, protect interiors from UV damage, and keep cooling bills manageable. Our custom solar screens are perfect for Sun City's classic ranch-style homes and patios.",
    highlights: [
      "Trusted by Sun City homeowners across the original villages",
      "Protects furnishings, flooring, and artwork from UV fading",
      "Reduces AC strain — important for fixed-income households",
      "Friendly, no-pressure estimates with senior-friendly service"
    ],
    neighborhoods: ["Sun City Original", "Sun City West", "Bell Camino", "Lakeview"],
    metaTitle: "Sun Screens Sun City AZ | Trusted Solar Screen Installer",
    metaDescription: "Custom sun screen installation in Sun City, AZ. Block heat & protect interiors. Free estimates. Senior-friendly service. Call (623) 301-4595.",
  },
  {
    slug: "el-mirage",
    name: "El Mirage",
    county: "Maricopa County",
    population: "35K+",
    avgTemp: "107°F",
    description: "El Mirage homeowners know the West Valley sun shows no mercy. Valley Sun Screens delivers affordable, professionally installed solar screens that keep El Mirage homes cooler, lower energy bills, and protect interiors from harsh UV exposure year-round.",
    highlights: [
      "Affordable pricing for El Mirage's growing neighborhoods",
      "Custom-built screens for every window size and style",
      "Same-week installation available",
      "Free in-home estimates with honest, upfront pricing"
    ],
    neighborhoods: ["Pulte Homes", "Sundial", "Thompson Ranch", "Dysart"],
    metaTitle: "Sun Screens El Mirage AZ | Affordable Solar Screens",
    metaDescription: "Affordable sun screen installation in El Mirage, AZ. Block the West Valley heat. Free estimates, fast install. Call (623) 301-4595.",
  },
  {
    slug: "waddell",
    name: "Waddell",
    county: "Maricopa County",
    population: "6K+",
    avgTemp: "107°F",
    description: "Waddell's rural-feel neighborhoods and large lots make custom sun screens a smart upgrade for keeping homes cool and patios usable through the long Arizona summer. Valley Sun Screens proudly serves Waddell with professional installations and honest pricing.",
    highlights: [
      "Serving Waddell's larger custom homes and rural properties",
      "Custom screens sized for oversized windows and patio doors",
      "Help keep indoor temps more comfortable",
      "Local West Valley installer — fast response times"
    ],
    neighborhoods: ["Cortessa", "White Tank Foothills", "Russell Ranch"],
    metaTitle: "Sun Screens Waddell AZ | Custom Solar Screen Installation",
    metaDescription: "Custom sun screen installation in Waddell, AZ. Block solar heat on large windows & patios. Free estimates. Call (623) 301-4595.",
  },
  {
    slug: "wittmann",
    name: "Wittmann",
    county: "Maricopa County",
    population: "3K+",
    avgTemp: "108°F",
    description: "Wittmann's wide-open desert living comes with intense sun exposure. Valley Sun Screens helps Wittmann homeowners tame the heat with custom solar screens built to last through years of brutal Arizona summers — keeping homes cooler and energy bills lower.",
    highlights: [
      "Built for Wittmann's intense desert sun exposure",
      "Heavy-duty screen materials that withstand wind and UV",
      "Custom sizing for every window and slider",
      "Free estimates — we travel to Wittmann at no extra charge"
    ],
    neighborhoods: ["Tonopah Valley", "Sun Valley Pkwy", "Patton Rd"],
    metaTitle: "Sun Screens Wittmann AZ | Heavy-Duty Solar Screens",
    metaDescription: "Custom sun screen installation in Wittmann, AZ. Heavy-duty screens for intense desert sun. Free estimates. Call (623) 301-4595.",
  },
];
